var _path, _ellipse, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiCharger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.67 13.7302C26.67 19.6563 21.6692 25.2857 15.835 29C9.58404 24.873 5 19.6563 5 13.7302C5 7.80406 9.85099 3 15.835 3C21.819 3 26.67 7.80406 26.67 13.7302Z",
    fill: "#408E8D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8351,
    cy: 12.9051,
    rx: 7.50115,
    ry: 7.42857,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0342 11.5566L19.0602 16.7335L19.5122 14.5375L21.6476 13.7866L16.0342 11.5566Z",
    fill: "#408E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.469 13.7866H10.417L12.1158 15.2714L11.7059 17.473L16.469 13.7866Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4021 13.0433L17.4281 7.86839L15.2773 8.57957L13.5518 7.12695L14.4021 13.0433Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiCharger);
export default __webpack_public_path__ + "static/media/mobiliti_charger.e2109cfb9173571ae7476212a462144a.svg";
export { ForwardRef as ReactComponent };